import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

function SearchTextField({ defaultValue, onSearch, inputProps }) {
    const _inputProps = inputProps || {};
    const [value, setValue] = useState(defaultValue);
    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);
    function handleInputChange(e) {
        setValue(e.target.value);
    }

    function handleOnKeyUp(e) {
        e.persist();

        if (e.keyCode === 13) {
            onSearch(e.target.value, e);
        }
    }

    return (
        <TextField
            {..._inputProps}
            variant="outlined"
            value={value}
            onChange={handleInputChange}
            onKeyUp={handleOnKeyUp}
        />
    );
}
export default SearchTextField;
